
import {defineComponent, onMounted, reactive, toRefs, computed} from "vue";
import ApiLogistics from "@/request/apis/api_logistics";
import router from "@/router";
import {message} from "ant-design-vue/es";
import StorageUtil from "@/utils/storage_util";
import PageUtil from "@/utils/page_util";
import {IBalanceItem, ICashItem} from "@/models/logistics_model";
import {amountFormat} from "@/utils/common";
import {balanceType, getBalanceType} from "@/utils/status";

interface IState {
  list: IBalanceItem[],
  total: number;
  loading: boolean;
  searches: any
  userType: 'user' | 'driver'
}

// 表格
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '用户',
    dataIndex: 'user',
    key: 'user',
  },
  {
    title: '变动之前金额',
    dataIndex: 'pre_balance',
    key: 'pre_balance',
    align: 'right'
  },
  {
    title: '变动金额',
    dataIndex: 'changed_amount',
    key: 'changed_amount',
    align: 'right'
  },
  {
    title: '余额',
    dataIndex: 'balance',
    key: 'balance',
    align: 'right'
  },
  {
    title: '变动类型',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: '变动时间',
    dataIndex: 'create_time',
    key: 'create_time',
  },
];

export default defineComponent({
  name: 'BalanceRecordList',
  setup() {
    const state: IState = reactive({
      list: [],
      total: 0,
      loading: false,
      userType: 'user',
      searches: {
        page_no: PageUtil.pageNo,
        page_size: PageUtil.pageSize,
      },
    })

    const pagination = computed(() => ({
      total: state.total,
      current: state.searches.page_no,
      pageSize: state.searches.page_size,
      showTotal: (total: any) => `共${total}条数据`,
      defaultPageSize: 10,
      // pageSizeOptions: ['5', '10', '15', '20'], // 可不设置使用默认
      showSizeChanger: true, // 是否显示pageSize选择
      showQuickJumper: true, // 是否显示跳转窗
    }));

    // 列表当前页更改
    const handleTableChange = (pages: any) => {
      state.searches.page_size = pages.pageSize
      state.searches.page_no = pages.current
      getList()
    };

    //获取列表
    const getList = async () => {
      let params = {...state.searches}
      StorageUtil.setParams(params)
      state.loading = true
      const res = await ApiLogistics.getBalanceRecord(params, state.userType)
      state.loading = false
      if (res && res.error_code === 0 && res.data) {
        state.total = res.data?.count || 0
        state.list = res.data?.list || []
      }
    }

    // 搜索
    const onSearch = (key: string, value: any) => {
      state.searches[key] = value
      state.searches.page_no = 1
      state.searches.page_size = PageUtil.pageSize
      getList()
    }
    // 选择用户
    const setUserType = (e: any) => {
      state.userType = e
      resetSearch()
    }

    // 重置search参数
    const resetSearch = () => {
      for (let key in state.searches) {
        state.searches[key] = ''
      }
      state.searches.page_no = 1
      state.searches.page_size = PageUtil.pageSize
      getList()
    }

    // 初始化search参数
    const initSearch = () => {
      const res = StorageUtil.getParams()
      if (res) {
        state.searches = {...state.searches, ...res}
      }
    }

    onMounted(() => {
      initSearch()
      getList()
    })

    return {
      ...toRefs(state),
      columns,
      pagination,
      handleTableChange,
      onSearch,
      resetSearch,
      amountFormat,
      balanceType,
      getBalanceType,
      setUserType,
    }
  }
})
